import { render } from "./AdminDash.vue?vue&type=template&id=3a9355eb&scoped=true"
import script from "./AdminDash.vue?vue&type=script&lang=js"
export * from "./AdminDash.vue?vue&type=script&lang=js"

import "./AdminDash.vue?vue&type=style&index=0&id=3a9355eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9355eb"]])

export default __exports__